import Vue from 'vue'
Vue.filter('numbersThousands', function (num) {
  if (num == 0)
    return 0;
  if (!num) return '';
  num = num.toLocaleString();
  return num;
})

Vue.filter("floorNumber", function (value) {
  return Math.floor(value)
});

Vue.filter("ceilNumber", function (value) {
  return Math.ceil(value)
});

Vue.filter('inCurrency', function (num) {
  return num + ' €';
})

Vue.filter('inPieces', function (num) {
  return num + ' pcs';
})

Vue.filter('inPercent', function (num) {
  return num + '%';
})

Vue.filter('formatTime', function (value) {
  let hours = Math.floor((value / (1000 * 60 * 60)) % 24)
  let minutes = Math.floor((value / (1000 * 60)) % 60)
  let seconds = Math.floor((value / 1000) % 60)

  let dHours = (hours > 9 ? hours : '0' + hours);
  let dMins = (minutes > 9 ? minutes : '0' + minutes);
  let dSecs = (seconds > 9 ? seconds : '0' + seconds);

  if (dHours > 0) {
    return dHours + ":" + dMins + ":" + dSecs;
  } else {
    return dMins + ":" + dSecs;
  }
})
